<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">
          Multicast Program Index {{ entryIdx }} 
        </div>
      </div>
    </div>
    <!--页面提示
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the multicast entry." }}
      </p>
    </div>-->
    <div>
      <span style="margin: 1px"></span>
    </div>
    <div>
      <div class="row">
        <div class="col-lg-12" v-show="true">
          <block-cntr
            :btitle="'multicast entry'"
            style="height: 100%"
            :closeButton="false"
          >
            <form class="form-horizontal">
              <div
                class="form-group"
                v-for="(value, key) in multicastEntryInfo"
                :key="key"
              >
                <div class="col-lg-3">
                  <label>{{ value.k }}</label>
                </div>
                <div class="col-lg-8">
                  <label>{{ value.v }}</label>
                </div>
              </div>
            </form>
          </block-cntr>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "profileMulticastEnrty",
  components: {
    BlockCntr,
  },
  data() {
    return {
      mcastIdx: this.$route.query.mcastIdx,
      entryIdx: this.$route.query.entryIdx,
      multicastEntryInfo: "",
    }
  },

  created() {
    this.loadmulticastProfileEntryInfo()
  },

  methods: {
    loadmulticastProfileEntryInfo() {
      get(
        "multicastProfileEntryInfo?mcastIdx=" +
          this.mcastIdx +
          "&entryIdx=" +
          this.entryIdx
      )
        .then((res) => (this.multicastEntryInfo = res.data))
        .catch((err) => {
          this.multicastEntryInfo = en.multicastEntryInfo
        })
    },
  },
}
</script>